/**
 * Building configuration constants
 */
import { Mode, Status } from '@/types';

export const BUILDING_CONFIG = {
  // Building information
  name: 'Alto Cero Demo Building',
  location: 'Bangkok, Thailand',
  gfa: 10000, // Gross Floor Area in square meters
  floors: 5,

  // Energy benchmarks
  energyUseIntensity: 145.00, // Current EUI value in kWh/m²·yr

  // Mock data for sensors and devices
  sensors: {
    temperature: {
      online: 12,
      total: 14
    },
    iaq: {
      online: 3,
      total: 4
    }
  },

  // Mock data for CCTV devices
  cctv: {
    online: 3,
    total: 5
  },

  // Default air quality values
  airQuality: {
    co2: 450,
    pm25: 15,
    pm10: 35,
    tvoc: 250
  },

  // Default operational data - values from the autopilot page screenshot
  operationalData: {
    averageWorking: 31.2, // Match the autopilot page (31.2%)
    avgToday: 22, // Match the autopilot page (22°C)
    units: [
      { status: 'alarm' as Status, type: 'cool' as Mode, count: 0 }, // Alarm units (0 unit)
      { status: 'on' as Status, type: 'cool' as Mode, count: 2 }, // On units (2 units)
      { status: 'off' as Status, type: 'cool' as Mode, count: 8 }, // Off units (8 units)
      { status: 'on' as Status, type: 'fan' as Mode, count: 2 }, // Fan units (2 units)
      { status: 'on' as Status, type: 'dry' as Mode, count: 0 } // Dry units (0 unit)
    ]
  },

  // Occupancy data from the autopilot page screenshot
  occupancyData: {
    currentOccupancy: 181, // Current occupancy (181 persons)
    peopleIn: 787, // People In (787 persons)
    peopleOut: 806, // People Out (806 persons)
    isOnline: true, // CCTV status is online
  },

  // Indoor Environment data from the autopilot page screenshot
  indoorEnvironment: {
    temperature: {
      current: 32.98, // Current temperature (32.98°C)
      average: 32.5 // Average temperature
    },
    humidity: {
      current: 57.14, // Current humidity (57.14%)
      average: 56.66 // Average humidity (56.66%)
    },
    sensorStatus: {
      tempHumidity: {
        online: 12,
        total: 14
      },
      iaq: {
        online: 3,
        total: 4
      }
    }
  },

  // Energy resource mapping data
  energyResourceMapping: {
    totalConsumption: 3213.8, // Total consumption in kWh
    totalImport: 2213.8, // Total import in kWh
    acConsumption: 128, // A/C consumption in kW
    otherConsumption: 156, // Other consumption in kW
    solarProduced: 375, // Solar production in kW
    gridImport: 138, // Grid import in kW
    importGridPercentage: 85, // Import Grid percentage
    solarCellPercentage: 15, // Solar Cell percentage
    acPercentage: 45, // A/C percentage
    otherPercentage: 55, // Other percentage
  },

  // Event types for event log - icon definitions should be in the component
  eventTypes: [
    { id: 'none', label: 'None', name: '', color: 'bg-light-grey' },
    { id: 'softStart', label: 'Soft Start', name: 'Softstart', color: 'bg-mid-blue', iconType: 'power' },
    { id: 'asp', label: 'ASP', name: 'ASP', color: 'bg-mid-orange', iconType: 'sun' },
    { id: 'flowSave', label: 'Flow Save', name: 'Flowsave', color: 'bg-green', iconType: 'waves' },
    { id: 'softClose', label: 'Soft Close', name: 'Softclose', color: 'bg-[#5E5E5E]', iconType: 'powerOff' },
    { id: 'apl', label: 'APL', name: 'APL', color: 'bg-purple', iconType: 'users' },
  ]
};

export default BUILDING_CONFIG;
